import {CatalogConfig} from '../types'

// Waiting-list catalogs — reasons the admin can pick when rejecting a candidate on the
// waitlist. Backed by waitinglist.RejectionReason. The read endpoint
// /waitinglist/rejection-reasons/ stays for the reject modal; admin CRUD lives under
// /catalog/admin/waitinglist-rejection-reasons/. Primary field is `reason` (not `name`).

export const waitinglistRejectionReasonsConfig: CatalogConfig = {
  slug: 'waitinglist-rejection-reasons',
  endpoint: '/catalog/admin/waitinglist-rejection-reasons/',
  titleId: 'CATALOG.WAITINGLIST_REJECTION_REASONS.TITLE',
  singularId: 'CATALOG.WAITINGLIST_REJECTION_REASONS.SINGULAR',
  primaryField: 'reason',
  writable: true,
  reorderable: true,
  softDelete: {field: 'isActive', activeValue: true},
  serverSide: {
    searchParam: 'search',
    orderingParam: 'ordering',
    statusParam: 'isActive',
    sortableFields: ['order', 'reason'],
    defaultOrdering: 'order',
  },
  fields: [
    {name: 'order', labelId: 'CATALOG.FIELD.ORDER', type: 'text', showInTable: true},
    {
      name: 'reason',
      labelId: 'CATALOG.FIELD.REASON',
      type: 'text',
      showInTable: true,
      searchable: true,
      required: true,
      maxLength: 150,
    },
  ],
}

export const waitinglistCatalogConfigs: CatalogConfig[] = [waitinglistRejectionReasonsConfig]
